import React from 'react';
import { 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin, 
  Phone, 
  Mail, 
  MapPin,
  Clock,
  ChevronRight
} from 'lucide-react';
import Logo from "../assets/Screenshot 2026-02-17 194019.png"
import logo1 from "../assets/newlogoo.13718ece22099e072453.png"

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
             <img src={Logo} alt="PlusCabs Logo" className="w-10 h-10" />
             
              <h2 className="text-2xl font-bold">
                <span className="text-yellow-400">Plus</span>
                <span className="text-white">Cabs</span>
              </h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted partner for comfortable and reliable cab services. 
              We're committed to providing the best transportation experience 
              with safety and comfort.
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4 pt-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition duration-300">
                <Facebook size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition duration-300">
                <Twitter size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition duration-300">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition duration-300">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-yellow-400">Quick Links</h3>
            <ul className="space-y-3">
              {['About Us', 'Our Services', 'Fleet', 'Book a Cab', 'Tariffs', 'FAQs'].map((item, index) => (
                <li key={index}>
                  <a href="#" className="text-gray-400 hover:text-yellow-400 transition duration-300 flex items-center group">
                    <ChevronRight size={16} className="mr-2 group-hover:translate-x-1 transition-transform" />
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-yellow-400">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="text-yellow-400 flex-shrink-0 mt-1" />
                <span className="text-gray-400 text-sm">
                  1st floor shop number s5 #28 3rd cross, Old Post Office Rd, near by carrymart supermarket, Madiwala, BTM 1st Stage, Bengaluru, Karnataka 560068
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={20} className="text-yellow-400" />
                <span className="text-gray-400">+91 73495 19354</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={20} className="text-yellow-400" />
                <span className="text-gray-400">info@pluscabs.com</span>
              </li>
              <li className="flex items-center space-x-3">
                <Clock size={20} className="text-yellow-400" />
                <span className="text-gray-400">24/7 Available</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-yellow-400">Newsletter</h3>
            <p className="text-gray-400 text-sm">
              Subscribe to get updates on special offers and new services.
            </p>
            <div className="space-y-3">
              <input
                type="email"
                placeholder="Your email address"
                className="w-full px-4 py-3 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
              />
              <button className="w-full bg-yellow-400 text-black font-semibold px-4 py-3 rounded-lg hover:bg-yellow-500 transition duration-300">
                Subscribe Now
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar - Updated with Freelancer Credit */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2026 PlusCabs. All rights reserved.
            </div>
            
            {/* Freelancer Credit with Logo */}
            {/* <div className="flex items-center space-x-2">
              <span className="text-gray-500 text-sm">Developed by</span>
              <a 
                href="https://www.freelancerx.in" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-1 group"
              >
                <span className="text-yellow-400 font-semibold group-hover:text-yellow-300 transition duration-300">
                  FreelancerX
                </span>
                <img src={logo1} alt="FreelancerX Logo" className="w-8 h-8 bg-gray-200 rounded-full" />
              </a>
            </div> */}

            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition duration-300">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition duration-300">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition duration-300">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;